import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import {Modal, Button, Row, Col, Glyphicon, FormControl, Tabs, Tab} from 'react-bootstrap';
import {Responsive, WidthProvider} from "react-grid-layout";
import stylesMorphoRule from "../../../_css/dictionary/lexemeParts/lexemeMorphoRule.module.css";

const ResponsiveReactGridLayout = WidthProvider(Responsive);
import Dict from "dict-lib";
import './MorphoRuleGridLayout.css';
import {TreeDOMHelper} from "../../../dict-components/tree/components/TreeHelper";
import BUtils from './../../../utilities/BaseUtilities';
import FontAwesome from "react-fontawesome";
import ReactTooltip from "react-tooltip";
import stylesSCTree from "../../../dict-components/tree/SCTree.module.css";
import {SCRadiobutton} from "../../../dict-components/radiobutton/SCRadiobutton";
import ReactDOM from "react-dom";
import stylesScNavbar from "../../../dict-components/navbar/ScNavbar.module.css";
import {Notifications} from "../../../utilities/DictUtilities";


export class MorphoRuleGridLayout extends React.Component {
    constructor(props) {
        super(props);

        const cgrsLabel = [/*{value: 'Gruppo', type: 'group'},*/
            {value: 'Tempo verbale', type: 'mode'}
        ];

        const droppingItem = {w: 2, h: 2, i: 'new item'};

        this.state = {
            currentBreakpoint: "lg",
            compactType: "vertical",
            mounted: false,
            layouts: {lg: []}/*{lg: props.initialLayout}*/,
            cgrs: [],
            originalSchemaGroups: [],
            schemaGroups: [],
            selectedGroup: null,
            renameGroup: false,
            cgrsLabel,
            droppingItem,
            mode: typeof this.props.mode !== 'undefined' ? 'EDIT' : this.props.mode
        };

        this.hasDeclinedForm = typeof this.props.subentryId !== 'undefined';

        this.schemaButtons = [
            {
                icon: 'plus',
                operation: 'ADD_GROUP'
            },
            {
                icon: 'minus',
                operation: 'REMOVE_GROUP'
            },
            {
                icon: 'caret-left',
                operation: 'SHIFT_GROUP_LEFT'
            },
            {
                icon: 'caret-right',
                operation: 'SHIFT_GROUP_RIGHT'
            },
            {
                icon: 'pencil',
                operation: 'RENAME_GROUP'
            },
            {
                icon: 'ban',
                operation: 'SET_HIDE'
            },
            {
                icon: 'eye',
                operation: 'SET_ADVANCED_MODE'
            },
            {
                icon: 'save',
                operation: 'SAVE'
            },
        ];

        this.onBreakpointChange = this.onBreakpointChange.bind(this);
        this.onCompactTypeChange = this.onCompactTypeChange.bind(this);
        this.generateDOM = this.generateDOM.bind(this);
        this.onLayoutChange = this.onLayoutChange.bind(this);
        this.onNewLayout = this.onNewLayout.bind(this);
        this.onDrop = this.onDrop.bind(this);
    }

    componentWillMount() {

    }

    componentDidMount() {
        this.setState({mounted: true}, () => {
            this._performCheckRuleSchema();
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!this.hasDeclinedForm) {
            TreeDOMHelper._dragElement('cgrs-container', 'cgrs-container-header');
        } else {
            if (this.hasDeclinedForm) {
                var eles = document.getElementsByClassName('react-resizable-handle');
                for (const ele of eles) {
                    ele.style.display = 'none';
                }
            }
        }
    }

    _performCheckRuleSchema() {
        var params = this.props.ruleId + '/' + '/' + this.props.mode + '/' + '/' + this.props.printMode + '/' + (this.hasDeclinedForm ? this.props.subentryId + '/' : '');
        Dict.call('/declinedForms/checkRuleSchema/' + params).then((result) => {
            const cgrs = result.transformationRules.map((rule) => {
                return {value: rule.label, type: 'cgr', id: rule.id, orderFactor: rule.orderFactor};
            });
            const schemaGroups = this._schemaItemToRadioItem(result.schemaGroups);
            var originalSchemaGroups = BUtils.cloneJson(schemaGroups);
            const selectedGroup = BUtils.cloneJson(schemaGroups[0]);
            var layouts = {lg: schemaGroups[0].layout};

            this.setState({cgrs, schemaGroups, selectedGroup, originalSchemaGroups, layouts});
        })
    }

    _schemaItemToRadioItem(schemaGroups) {
        return schemaGroups.map((schemaGroup) => {
            return {
                code: schemaGroup.id,
                label: schemaGroup.groupName,
                layout: schemaGroup.layout,
                orderFactor: schemaGroup.orderFactor,
                hidden: schemaGroup.hidden,
                advancedMode: schemaGroup.advancedMode
            };
        });
    }

    _radioItemToSchemaItem(radioItems) {
        return radioItems.map((radioItem) => {
            return {
                id: radioItem.code,
                groupName: radioItem.label,
                layout: radioItem.layout,
                orderFactor: radioItem.orderFactor,
                hidden: radioItem.hidden,
                advancedMode: radioItem.advancedMode
            };
        })
    }


    _generateCgrsDOM(collection) {
        return collection.map((item, index) => {
            const top = (35 + 28 * index) + 'px';
            const left = '5px';
            const id = 'item-' + index;

            return <div key={'key-item-' + index} id={id} draggable={true} data-grid-type={item.type}
                        onDragStart={(e) => {
                            e.dataTransfer.setData("data", JSON.stringify(item));
                            var gridLayout = document.getElementsByClassName('react-grid-layout')[0];
                            gridLayout.style.outline = '1px solid #dcdcdc';
                            gridLayout.style.height = (parseInt(gridLayout.style.height) + 50) + 'px';

                            var droppingItem = this.state.droppingItem;
                            if (item.type === 'group') {
                                droppingItem.w = 12;
                            } else if (item.type === 'mode') {
                                droppingItem.w = 2;
                            } else {
                                droppingItem.w = 2;
                            }

                            this.setState({droppingItem});
                        }}

                        className={BUtils.joinClasses(stylesMorphoRule['morpho-rule-grid-cgrs__item'], stylesMorphoRule['morpho-rule-grid-cgrs__item-' + item.type])}
                        style={{top, left}} onMouseUp={(e) => {
            }}>{item.value}</div>;
        })
    }


    _isReactGridItem(element) {
        return element.classList.contains('react-grid-item');
    }

    _addTenseGroup() {

    }

    _addTense() {

    }

    _addTenseForm() {

    }

    _openCloseAskRemove(i, isOpen) {
        document.getElementById('cgr-dom-ask-remove-' + i).style.display = isOpen ? 'block' : 'none';
    }

    _closeAllAskRemove() {
        var els = document.getElementsByClassName(stylesMorphoRule['morpho-rule-grid-item__ask-remove']);
        for (const el of els) {
            el.style.display = 'none';
        }
    }

    _onClickDeclinedForm(layouts, item, i, text) {
        item.newText = text;
        this.setState({layouts});
        this._openCloseAskRemove(i, false);
        var cgrDomInput = document.getElementById('cgr-dom-input-' + i);
        cgrDomInput.style.display = cgrDomInput.style.display === 'inline' ? 'none' : 'inline';
        cgrDomInput.focus();
    }

    generateDOM() {

        if (this.props.mode === 'PRINT') {
            return this._buildReadOnlyTemplate();
        } else return _.map(this.state.layouts.lg, (l, i) => {
            var hasDeclinedForm = this.hasDeclinedForm;

            var layouts = this.state.layouts;
            var item = layouts.lg.find((item) => {
                return item.i === i;
            });

            l.isDraggable = !hasDeclinedForm;
            l.isResizable = !hasDeclinedForm;

            return (
                <div key={i}
                     id={'cgr-dom-' + i}
                     className={l.static ? "static" : ""}
                     data-grid={l}
                >
                    <div
                        className={BUtils.joinClasses(stylesMorphoRule['morpho-rule-cgr-item__text-container'])}>
                        <div
                            className={BUtils.joinClasses(stylesMorphoRule['morpho-rule-grid-cgr-item__text'])}>{item.readOnlyText}</div>
                        {!this.hasDeclinedForm ? <div className={stylesMorphoRule['morpho-rule-cgr-item__text__remove']}
                                                      onClick={() => {
                                                          this._openCloseAskRemove(i, true);
                                                      }}>
                            <FontAwesome name={'close'}/>
                        </div> : ''}
                    </div>
                    <div
                        className={BUtils.joinClasses(stylesMorphoRule['morpho-rule-grid-item__declined__container'], stylesMorphoRule['morpho-rule-grid-item__declined__container--' + hasDeclinedForm])}>
                        <div
                            className={BUtils.joinClasses(stylesMorphoRule['morpho-rule-grid-item__text'], stylesMorphoRule['morpho-rule-grid-item__text--' + item.type], stylesMorphoRule['morpho-rule-grid-item__text__editable--' + hasDeclinedForm])}
                            onClick={() => {
                                if (!hasDeclinedForm)
                                    this._onClickDeclinedForm(layouts, item, i, l.text);
                            }}>{l.text}</div>
                        {hasDeclinedForm ? <div
                            className={BUtils.joinClasses(stylesMorphoRule['morpho-rule-grid-item__declined-form'], stylesMorphoRule['morpho-rule-grid-item__declined-form__editable--' + hasDeclinedForm])}
                            onClick={() => {
                                this._onClickDeclinedForm(layouts, item, i, l.declinedForm);
                            }}
                        >{l.declinedForm}</div> : ''}
                    </div>
                    <div id={'cgr-dom-ask-remove-' + i}
                         className={BUtils.joinClasses(stylesMorphoRule['morpho-rule-grid-item__ask-remove'])}>
                        <span>{Dict.t('ASK_DELETE_RULE')}</span>
                        <Button onClick={() => {
                            var layouts = this.state.layouts;
                            var selectedGroup = this.state.selectedGroup;
                            var cgrs = this.state.cgrs;

                            const maxY = selectedGroup.layout.reduce(function (prev, current) {
                                return (prev && prev.y > current.y) ? prev : current
                            });

                            var maxDepthItem = selectedGroup.layout.find((layoutItem) => {
                                return layoutItem.i === item.i;
                            });

                            maxDepthItem.y = maxY.y + 2;

                            var schemaGroups = this.state.schemaGroups;
                            schemaGroups[0] = selectedGroup;
                            var oldLg = BUtils.cloneJson(layouts.lg);
                            layouts.lg = [];

                            this._resetSelectedGroup(selectedGroup, () => {
                                this.setState({schemaGroups});
                                layouts.lg = oldLg;
                                _.remove(layouts.lg, function (item) {
                                    return item.i === i;
                                });

                                layouts.lg.forEach((item, i) => {
                                    item.i = i;
                                });

                                selectedGroup.layout = layouts.lg;
                                document.getElementById('cgr-dom-' + i).style.visibility = 'hidden';
                                this.setState({selectedGroup}, () => {
                                    this._closeAllAskRemove();
                                    if (item.type === 'cgr') {
                                        Dict.call('/declinedForms/getCgrById/' + item.id + '/').then((result) => {
                                            document.getElementsByClassName('react-grid-layout layout')[0].style.opacity = '0';
                                            cgrs.push({
                                                value: result.value,
                                                type: 'cgr',
                                                id: result.id,
                                                orderFactor: result.orderFactor
                                            });
                                            cgrs.sort(function (a, b) {
                                                if (a.orderFactor < b.orderFactor)
                                                    return -1;
                                            });
                                            this.setState({cgrs, layouts}, () => {
                                                setTimeout(function () {
                                                    document.getElementsByClassName('react-grid-layout layout')[0].style.opacity = '1';
                                                    var eles = document.getElementsByClassName('react-grid-layout layout')[0].getElementsByClassName('react-grid-item');
                                                    for (const ele of eles) {
                                                        ele.style.visibility = 'visible';
                                                    }
                                                }, 400);
                                            });
                                        });
                                    }
                                });
                            });

                        }}>{Dict.t('YES')}</Button>
                        <span>/</span>
                        <Button onClick={() => {
                            this._openCloseAskRemove(i, false);
                        }}>{Dict.t('NO')}</Button>
                    </div>
                    <div
                        className={BUtils.joinClasses(stylesMorphoRule['morpho-rule-grid-item__edit-text'], stylesMorphoRule['morpho-rule-grid-item__edit-text--' + item.type])}>
                        <FormControl type="text"
                                     id={'cgr-dom-input-' + i}
                                     ref={(input) => {
                                         /*this.firstDating = input;*/
                                     }}
                                     value={typeof l.newText === 'undefined' ? l.text : l.newText}
                                     onChange={(evt) => {
                                         item.newText = evt.target.value;
                                         this.setState({layouts});
                                     }}

                                     onKeyUp={
                                         (evt) => {
                                             if (evt.keyCode === 13) {
                                                 item[hasDeclinedForm ? 'declinedForm' : 'text'] = item.newText;
                                                 delete item.newText;
                                                 var layouts = this.state.layouts;
                                                 this.state.selectedGroup.layout = BUtils.cloneJson(layouts.lg);
                                                 this.setState({layouts});
                                                 document.getElementById('cgr-dom-input-' + i).style.display = 'none';
                                                 if (hasDeclinedForm) {
                                                     Dict.call('/subentries/saveFromFromTemplate/' + item.declinedFormId + '/' + item.declinedForm + '/')
                                                 }
                                             } else if (evt.keyCode === 27) {
                                                 document.getElementById('cgr-dom-input-' + i).style.display = 'none';
                                             }
                                         }
                                     }
                        />
                    </div>
                </div>
            );
        });
    }

    _buildReadOnlyTemplate() {
        var ret = _.map(this.state.layouts.lg, (l, i) => {
            var layouts = this.state.layouts;
            var item = layouts.lg.find((item) => {
                return item.i === i;
            });

            l.isDraggable = false;
            l.isResizable = true;

            return <div key={i}
                        id={'cgr-dom-' + i}
                        className={BUtils.joinClasses((l.static ? "static" : ""), stylesMorphoRule['morpho-rule-print-item--' + l.type])}
                        data-grid={l}
            >
                <div
                    className={BUtils.joinClasses(stylesMorphoRule['morpho-rule-print-text__text'], stylesMorphoRule['morpho-rule-print-text__text--' + l.type])}>{item.text}</div>
                {l.type === 'cgr' ? <div
                    className={BUtils.joinClasses(stylesMorphoRule['morpho-rule-print-text__declined-form'])}
                >{l.declinedForm}</div> : ''}
            </div>;
        });

        return ret;
    }

    onDrop(lg, layoutItem, e) {
        var layouts = this.state.layouts;
        var cgrs = this.state.cgrs;

        lg.forEach((item) => {
            if (item.i === 'new item') {
                var transferItem = JSON.parse(e.dataTransfer.getData("data"));
                item.type = transferItem.type;
                if (transferItem.type === 'mode') {
                    item.text = transferItem.value;
                } else {
                    item.text = Dict.t('PERSONAL_PRONOUN');
                    item.readOnlyText = transferItem.value;
                }

                item.id = transferItem.id;
                item.i = lg.length - 1;
                if (typeof layouts.lg === 'undefined')
                    layouts.lg = [];
                layouts.lg = layouts.lg.concat(Object.assign({}, layoutItem));
                layouts.lg.concat(Object.assign({}, layoutItem));

                var selectedGroup = this.state.selectedGroup;
                selectedGroup.layout = BUtils.cloneJson(layouts.lg);

                cgrs = cgrs.filter((cgr) => {
                    return transferItem.id !== cgr.id
                });
                this.setState({cgrs});

            }
        });

        var gridLayout = document.getElementsByClassName('react-grid-layout')[0];
        gridLayout.style.outline = '1px solid #dcdcdc';

        //layouts.lg = lg;

        /*layouts.lg.sort(function (a, b) {
            if (a.y < b.y)
                return -1;
            else if (a.y > b.y)
                return 1;
            if (a.x < b.x)
                return -1;
            else if (a.x > b.x)
                return 1;
            else
                return 0;
        });*/


        this.setState({layouts});
    }

    onBreakpointChange(breakpoint) {
        this.setState({
            currentBreakpoint: breakpoint
        });
    }

    onCompactTypeChange() {
        const {compactType: oldCompactType} = this.state;
        const compactType =
            oldCompactType === "horizontal"
                ? "vertical"
                : oldCompactType === "vertical"
                ? null
                : "horizontal";
        this.setState({compactType});
    }

    onLayoutChange(layout, layouts) {
        this.props.onLayoutChange(layout, layouts);

        var selectedGroup = this.state.selectedGroup;
        if (selectedGroup !== null) {
            if (typeof selectedGroup.layout !== 'undefined') {
                selectedGroup.layout.forEach((item, i) => {
                    item.w = layout[i].w;
                    item.h = layout[i].h;
                    item.x = layout[i].x;
                    item.y = layout[i].y;
                });
            } else
                selectedGroup.layout = [];

            /*selectedGroup.layout.sort((a, b) => {
                if (a.x !== b.x)
                    return a.x - b.x;
                else
                    return a.y - b.y;
            });*/

            this.setState({selectedGroup});
        }
    }

    onNewLayout() {
        this.setState({
            layouts: {lg: generateLayout()}
        });
    }

    _schemaButtonsAction(operation) {
        if (operation === 'ADD_GROUP') {
            var schemaGroups = this.state.schemaGroups;
            var size = schemaGroups.length;
            var newId = size + 1;
            var newGroup = {code: newId + '', label: 'new' + newId, orderFactor: newId + ''};
            schemaGroups.push(newGroup);

            this.setState({schemaGroups});
            this._resetSelectedGroup(newGroup);
        } else if (operation === 'REMOVE_GROUP') {
            if (this.state.selectedGroup.layout.length > 0) {
                Notifications.showToastNotification(Dict.t('MORPHO_GROUP_NOT_EMPTY'), 3000, 100);
            } else {
                schemaGroups = this.state.schemaGroups;
                var selectedGroup = this.state.selectedGroup;
                _.remove(schemaGroups, (item) => {
                    return item.code === this.state.selectedGroup.code;
                });

                this.setState({schemaGroups}, () => {
                    if (schemaGroups.length > 0) {
                        this._resetSelectedGroup(schemaGroups[0]);
                        //document.getElementById('sc-radio-morpho-rule-schema-groups').getElementsByTagName('button')[0].click();
                    }
                });
            }
        } else if (operation === 'SAVE') {
            var ruleSchema = this._radioItemToSchemaItem(this.state.schemaGroups);
            //ruleSchema.layout = this.state.layouts.lg;

            ruleSchema.find((group) => {
                return group.id === this.state.selectedGroup.code;
            }).layout = this.state.selectedGroup.layout;//this.state.layouts.lg;


            Dict.call('/declinedForms/saveRuleSchema/' + this.props.ruleId + '/', {
                method: 'POST',
                data: ruleSchema,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',

                }
            }).then((schemaGroups) => {
                const renameGroup = false;
                schemaGroups = this._schemaItemToRadioItem(schemaGroups);
                const originalSchemaGroups = BUtils.cloneJson(schemaGroups);
                this.setState({renameGroup, originalSchemaGroups, schemaGroups});
                //this._resetRules(result);
            });
        } else if (operation === 'RENAME_GROUP') {
            this.setState({renameGroup: !this.state.renameGroup}, () => {
                ReactDOM.findDOMNode(this.renameGroup).focus();
            });
        } else if (operation === 'SHIFT_GROUP_LEFT') {
            this._shiftGroup(true);
        } else if (operation === 'SHIFT_GROUP_RIGHT') {
            this._shiftGroup(false);
        } else if (operation === 'SET_HIDE') {
            this._changeGroupBooleanProperty('hidden');
        } else if (operation === 'SET_ADVANCED_MODE') {
            this._changeGroupBooleanProperty('advancedMode');
        }
    }

    _changeGroupBooleanProperty(property) {
        var selectedGroup = this.state.selectedGroup;
        var schemaGroups = this.state.schemaGroups;
        var isProperty = typeof selectedGroup[property] !== 'undefined' && selectedGroup[property];
        selectedGroup[property] = !isProperty;
        schemaGroups.find((group) => {
            return group.code === selectedGroup.code;
        })[property] = selectedGroup[property];
        this.setState({selectedGroup, schemaGroups});
    }

    _shiftGroup(isLeft) {
        var selectedGroup = this.state.selectedGroup;
        var schemaGroups = this.state.schemaGroups;
        var selectedOrderFactor = parseInt(selectedGroup.orderFactor);
        if ((isLeft && selectedOrderFactor === 1) || (!isLeft && selectedOrderFactor === schemaGroups.length)) {
            return;
        } else {
            this.state.schemaGroups.forEach((schemaGroup) => {
                const increment = isLeft ? -1 : 1;
                var orderFactor = parseInt(schemaGroup.orderFactor);
                if (isLeft && (orderFactor === selectedOrderFactor - 1)) {
                    orderFactor = (parseInt(orderFactor) + 1) + '';
                } else if (!isLeft && (orderFactor === selectedOrderFactor + 1)) {
                    orderFactor = (parseInt(orderFactor) - 1) + '';
                } else if (schemaGroup.code === selectedGroup.code) {
                    orderFactor = (parseInt(orderFactor) + increment) + '';
                    selectedGroup.orderFactor = orderFactor + '';
                }

                schemaGroup.orderFactor = orderFactor + '';
            });

            schemaGroups.sort(function (a, b) {
                if (a.orderFactor < b.orderFactor)
                    return -1;
            });

            this.setState({schemaGroups, selectedGroup});
        }
    }

    _checkIsModifiedGroup() {
        const selectedGroup = this.state.selectedGroup;
        const originalSelectedGroup = this.state.originalSchemaGroups.find((group) => {
            return group.code === selectedGroup.code;
        });

        return !_.isEqualWith(this.state.originalSchemaGroups, this.state.schemaGroups) ||
            !_.isEqualWith(selectedGroup.layout, this.state.layouts.lg) ||
            !_.isEqualWith(selectedGroup.hidden, originalSelectedGroup.hidden) ||
            !_.isEqualWith(selectedGroup.advancedMode, originalSelectedGroup.advancedMode);
    }

    _buildSchemaButtons() {
        return this.schemaButtons.map((button, index) => {
            const idTooltip = 'id-tooltip-schema-button-' + index;

            var additionalClass = '';
            if (button.operation === 'SAVE' && this.state.schemaGroups.length > 0) {
                const isModified = this._checkIsModifiedGroup();
                additionalClass = isModified ? stylesMorphoRule['morpho-rule-schema-button-unsaved'] : '';
            }

            return <span data-tip
                         data-for={idTooltip}>
                <Button className={BUtils.joinClasses(stylesMorphoRule['morpho-rule-schema-button'], additionalClass)}
                        onClick={() => {
                            this._schemaButtonsAction(button.operation)
                        }
                        }>
                    <ReactTooltip id={idTooltip} type={'info'} delayShow={300}>{Dict.t(button.operation)}</ReactTooltip>
                    <FontAwesome name={button.icon}/>
                </Button>
                </span>
        })
    }

    _buildSchemaGroups() {
        return this.state.selectedGroup !== null ?
            <>
                <SCRadiobutton default={this.state.selectedGroup.code}
                               key={'morpho-radio-selected-group'}
                               label={this.hasDeclinedForm ? '' : 'Gruppi'}
                               id={'sc-radio-morpho-rule-schema-groups'}
                               items={this.state.schemaGroups}
                               bsStyle={this.hasDeclinedForm ? 'default' : 'primary'}
                               callbackParent={(code) => {
                                   var schemaGroups = this.state.schemaGroups;
                                   var oldSelectedGroup = this.state.schemaGroups.find((schemaGroup) => {
                                       return schemaGroup.code === this.state.selectedGroup.code;
                                   });

                                   oldSelectedGroup.layout = this.state.layouts.lg;

                                   var newSelectedGroup = this.state.schemaGroups.find((schemaGroup) => {
                                       return schemaGroup.code === code;
                                   });

                                   this.setState({schemaGroups}, () => {
                                       this._resetSelectedGroup(newSelectedGroup);
                                   });
                               }}/>
                {this.props.mode === 'EDIT' ? <div
                    className={BUtils.joinClasses(stylesMorphoRule['morpho-rules-bar-item__message'], stylesMorphoRule['morpho-rules-bar-item__message--' + this.hasDeclinedForm])}>{this._printGroupMessage()}</div> : ''}
            </> : ''
    }

    _printGroupMessage() {
        if (this.state.selectedGroup.hidden) {
            return "gruppo non visibile";
        } else if (this.state.selectedGroup.advancedMode) {
            return "gruppo visibile solo in modalità avanzata";
        }
    }

    _resetSelectedGroup(selectedGroup, callback) {
        var layouts = {lg: selectedGroup.layout};
        this.setState({selectedGroup, layouts}, () => {
            if (typeof callback !== 'undefined')
                callback();
        });
    }

    _hideShowRename() {
        this.setState({renameGroup: !this.setState.renameGroup});
    }


    render() {
        return (
            <div>
                {!this.hasDeclinedForm ?
                    <div id={'cgrs-container'} className={stylesMorphoRule['morpho-rule-grid-cgrs']}>
                        <div id={'cgrs-container-header'} className={stylesMorphoRule['morpho-rule-grid-cgrs-header']}>
                            Cgrs
                        </div>
                        <div className={stylesMorphoRule['morpho-rule-grid-cgrs-label']}>
                            {this._generateCgrsDOM(this.state.cgrsLabel)}
                        </div>
                        <div className={stylesMorphoRule['morpho-rule-grid-cgrs__container']}>
                            {this._generateCgrsDOM(this.state.cgrs)}
                        </div>
                    </div> : ''}
                <div className={stylesMorphoRule['morpho-rules-bar']}>
                    {!this.hasDeclinedForm ?
                        <div id={'morpho-rules-buttonbar'} className={stylesMorphoRule['morpho-rules-bar-buttons']}>
                            {this._buildSchemaButtons()}
                        </div> : ''}
                    <div id={'morpho-rules-rename-group'} className={stylesMorphoRule['morpho-rules-bar-buttons']}>
                        <FormControl type="text"
                                     className={stylesMorphoRule['morpho-rules-rename-group-input--' + this.state.renameGroup]}
                                     key={'key-morpho-rules-rename-group-input'}
                                     id={'morpho-rules-rename-group-input'}
                                     ref={(input) => {
                                         this.renameGroup = input;
                                     }}
                                     value={this.state.selectedGroup !== null ? this.state.selectedGroup.label : ''}
                                     onChange={(evt) => {
                                         var selectedGroup = this.state.selectedGroup;
                                         selectedGroup.label = evt.target.value;
                                         this.setState({selectedGroup});
                                     }}

                                     onKeyUp={
                                         (evt) => {
                                             if (evt.keyCode === 13) {
                                                 var schemaGroups = this.state.schemaGroups;
                                                 var group = schemaGroups.find((schemaGroup) => {
                                                     return schemaGroup.code === this.state.selectedGroup.code;
                                                 });
                                                 group.label = this.state.selectedGroup.label;
                                                 this.setState({schemaGroups});
                                                 this._hideShowRename();
                                                 this._schemaButtonsAction('SAVE');
                                             } else if (evt.keyCode === 27) {
                                                 this._hideShowRename();
                                             }

                                         }
                                     }
                        />
                    </div>
                </div>
                <div id={'morpho-rules-schema-groups'}
                     className={BUtils.joinClasses(stylesMorphoRule['morpho-rules-bar-item'], stylesMorphoRule['morpho-rules-bar-item--' + this.hasDeclinedForm])}>
                    {this._buildSchemaGroups()}
                </div>
                <div className={BUtils.joinClasses('react-grid-layout-container', stylesMorphoRule['react-grid-layout-container--' + this.props.mode])}>
                    <ResponsiveReactGridLayout
                        {...this.props}
                        layouts={this.state.layouts}
                        autoSize={true}
                        onBreakpointChange={this.onBreakpointChange}
                        onLayoutChange={this.onLayoutChange}
                        onDrop={this.onDrop}
                        rowHeight={this.props.mode === 'PRINT' ? 10 : 30}
                        droppingItem={this.state.droppingItem}
                        margin={this.props.mode === 'PRINT' ? [3, 2] : [10, 10]}
                        containerPadding={this.props.mode === 'PRINT' ? [0,0] : [20, 20]}
                        // WidthProvider option
                        measureBeforeMount={false}
                        // I like to have it animate on mount. If you don't, delete `useCSSTransforms` (it's default `true`)
                        // and set `measureBeforeMount={true}`.
                        useCSSTransforms={this.state.mounted}
                        compactType={this.state.compactType}
                        preventCollision={!this.state.compactType}
                        isDroppable={!this.hasDeclinedForm}
                        /*onDragStart={(layout, oldItem, newItem, placeholder, e, element) => {
                            //e.stopPropagation();
                        }}*/
                    >
                        {this.generateDOM()}
                    </ResponsiveReactGridLayout>
                </div>
            </div>
        );
    }
}

MorphoRuleGridLayout.propTypes = {
    onLayoutChange: PropTypes.func.isRequired
};

MorphoRuleGridLayout.defaultProps = {
    className: "layout",
    rowHeight: 30,
    onLayoutChange: function () {
        console.log();
    },
    cols: {lg: 12, md: 10, sm: 6, xs: 4, xxs: 2},
    initialLayout: generateLayout()
};

function generateLayout() {
    return [];
    /*return [{
        x: 0,
        y: 0,
        w: 2,
        h: 2,
        i: 0,
        static: false, //Math.random() < 0.05,
        minH: 4,
        text: 'ecchime'
    }];*/

    /*return _.map(_.range(0, 4), function (item, i) {
        var y = Math.ceil(Math.random() * 4) + 1;
        return {
            x: (_.random(0, 5) * 2) % 12,
            y: Math.floor(i / 6) * y,
            w: 2,
            h: 4, //5 y <= 4 ? 4 : y,
            i: i.toString(),
            static: false, //Math.random() < 0.05,
            minH: 4,
            text: i + ''
        };
    });*/
}

/*

 /*onDragEnter={(e) => {
                         console.log('entro ' + e.target.id);
                         //if (isReactGridItem(e.target)) {
                         e.target.style.outline = '2px dotted red';
                         //}
                     }}

                     onDragLeave={(e) => {
                         console.log('esco ' + e.target.id);
                         //if (isReactGridItem(e.target)) {
                         e.target.style.outline = 'none';
                         //}
                     }}

                     onDragOver={(e) => {
                         e.stopPropagation();
                         e.preventDefault();
                     }}

                     onDrop={(e) => {
                         console.log('droppo ' + e.target.id);
                         var data = e.dataTransfer.getData("data");
                         e.target.children[0].innerText = data;
                         e.target.style.outline = 'none';
                     }}*/

{/*<div>
                    Current Breakpoint: {this.state.currentBreakpoint} ({
                    this.props.cols[this.state.currentBreakpoint]
                }{" "}
                    columns)
                </div>*/
}
{/*<div>
                    Tipo di compattazione:{" "}
                    {_.capitalize(this.state.compactType) || "Nessuna"}
                </div>*/
}
{/*<button onClick={this.onNewLayout} style={{marginRight: '3px'}}>Nuovo Layout</button>
                <button onClick={this.onCompactTypeChange}>
                    Cambia compattazione
                </button>*/
}



